import { DefaultApi } from '../../../api';
import { urls } from '../../../urls';
import { Action } from '../../../action';
import { getCatchError } from '../../../getCatchError';

const setGetViewBonuses = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_VIEW_BONUSES
            });

            if (data.status === 'success') {
                const temp = {
                    id: data.data.id ? data.data.id : 0,
                    label: data.data.label ? data.data.label : '',
                    bonus_name: data.data.bonus_name ? data.data.bonus_name : '',
                    template: data.data.currency ? data.data.currency : 'RUB',
                    bonus_start: data.data.bonus_start ? new Date(+data.data.bonus_start) : 0,
                    bonus_end: data.data.bonus_end ? new Date(+data.data.bonus_end) : 0,
                    max_activation_time: data.data.max_activation_time ? data.data.max_activation_time : 24,
                    fix_size_bonus: data.data.fix_size_bonus ? data.data.fix_size_bonus : 0,
                    wager: data.data.wager ? data.data.wager : 0,
                    max_time_roleplaying: data.data.max_time_roleplaying ? data.data.max_time_roleplaying : 168,
                    percent: data.data.percent ? data.data.percent : 100,
                    min_bet: data.data.min_bet ? data.data.min_bet : 0,
                    max_bet: data.data.max_bet ? data.data.max_bet : 1000,
                    min_balance_close_bonus: data.data.min_balance_close_bonus ? data.data.min_balance_close_bonus : 0,
                    min_sum_deposit: data.data.min_sum_deposit ? data.data.min_sum_deposit : 0,
                    max_sum_deposit: data.data.max_sum_deposit ? data.data.max_sum_deposit : 1000,
                    percent_of_deposit: data.data.percent_of_deposit ? data.data.percent_of_deposit : 0,
                    wager_percent: data.data.wager_percent ? data.data.wager_percent : 0,
                    max_size_bonus_of_deposit: data.data.max_size_bonus_of_deposit ? data.data.max_size_bonus_of_deposit : 0,
                    promocode: data.data.promocode ? data.data.promocode : '',
                    cashback_percent: data.data.cashback_percent ? data.data.cashback_percent : 0,
                    min_sum_bonus: data.data.min_sum_bonus ? data.data.min_sum_bonus : 0,
                    min_sum_balance: data.data.min_sum_balance ? data.data.min_sum_balance : 0,
                    day: data.data.day ? data.data.day : 'Понедельник',
                    description: data.data.description ? data.data.description : '',
                    denomination: data.data.denomination ? data.data.denomination : null,
                    bet_id: data.data.bet_id ? data.data.bet_id : null,
                    total_bets: data.data.total_bet ? data.data.total_bet : null,
                    game_uuid: data.data.game_uuid ? data.data.game_uuid : '',
                    quantity: data.data.quantity ? data.data.quantity : ''
                }

                dispatch(Action.SetGetViewBonusesAction(temp));
            }
        } catch (error) {
            getCatchError(error)
        }
    }
}


export {
    setGetViewBonuses as SetGetViewBonuses
}